/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'app/components/common/SideBar.jsx';
import { Breakpoint } from 'react-socks';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import SocialEditor from 'app/views/Settings/SocialEditor.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class ClientSocialEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            navItems: [
                {
					iconClass: 'fa fa-users sidebar-icon',
					label: 'Social Accounts',
					labelClass: 'sidebar-label',
					link: '/socials',
					badgeValueCallback: this.props.socials.counts,
					badgeClass: 'sidebar-item-badge'
				}
            ]
        };

    }

    render() {
        return (
            <div>
				<ErrorBoundary level="view" {...this.props}>
					<Breakpoint desktop only>
						<Sidebar navItems={this.state.navItems} app="client"/>
					</Breakpoint>
					<SocialEditor appName="client" {...this.props}/>
				</ErrorBoundary>
			</div>
        );
    }
}

ClientSocialEditor.displayName = "ClientSocialEditor";

ClientSocialEditor.propTypes = {

};

ClientSocialEditor.defaultProps = {

};

export default ComponentWithContext(ClientSocialEditor);
